import {createContext} from "react";

export type StickyHeaderContextType = {offset: number};

export const stickyHeaderContext = createContext<StickyHeaderContextType>({offset: 0});
